import { HttpResponse, delay, http } from 'msw';
import { API, BASE_URL_V2 } from '../../../src/common/constants';
import { generateIsolineMock } from '../data/isolineDataMock';

const REQUEST_DELAY_REALISTIC = undefined;
const VEHICLE_ISOLINE_URL = `${BASE_URL_V2}${API.endpoints.vehicles}/:id${API.endpoints.isoline}`;

export const mockedVehicleIsolineResponse = http.get(VEHICLE_ISOLINE_URL, async ({ request }) => {
    await delay(REQUEST_DELAY_REALISTIC);
    const params = new URL(request.url).searchParams;
    const origin = params.get('origin') ?? '0,0';
    const [lat, lng] = origin.split('');

    return HttpResponse.json(generateIsolineMock());
});

const vehicleIsolineEmptyResponse = http.get(VEHICLE_ISOLINE_URL, () => {
    return HttpResponse.json({ items: [] });
});

const vehicleIsolineErrorResponse = http.get(VEHICLE_ISOLINE_URL, async ({ request: _request }) => {
    await delay(REQUEST_DELAY_REALISTIC);

    return HttpResponse.json(null, { status: 500 });
});

export const VehicleIsolineResponse = {
    success: mockedVehicleIsolineResponse,
    empty: vehicleIsolineEmptyResponse,
    error: vehicleIsolineErrorResponse,
};
